import script from "./PricingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingSection.vue?vue&type=script&setup=true&lang=js"

import "./PricingSection.vue?vue&type=style&index=0&id=2d595d84&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d595d84"]])

export default __exports__